import './SliderValueLabel.e17194e0af20d4b2b04d4af12ec21158.css';
export default {"container":"_container_10y1w_1","label":"_label_10y1w_1","labelInput":"_labelInput_10y1w_1"};